<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Thống kê số lần xe qua trạm thu phí
            </h2>
            <hts-data-table
                ref="dataTable"
                class="w-full mt-4"
                :headers="headers()"
                :query-extend="filters"
                row-selection="single"
                enable-cell-change-flash
                :server="$url.report.getTollStationVehicle" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)
const vehicles = ref<null | Array<any>>()
const dataTable = ref()

const headers = () => {
  let headersDefault = [
    {
      field: 'name',
      headerName: $t('labels.tollStation')
    }
  ] as any[]

  const headersVehicle: any = [
    ...(vehicles?.value?.map((item: any) => {
      const id = item._id
      return {
        headerName: item.licensePlate,
        sortable: false,
        valueGetter: (params: any) => {
          const { vehicleCategory } = params.data
          const number = vehicleCategory?.[id]
          if (!number) {
            return ''
          }
          return $formatters.formatNumber(number)
        }
      }
    }) || [])
  ]

  headersDefault = headersDefault.concat(headersVehicle)

  return headersDefault
}

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

const refreshTable = $lodash.debounce(() => {
  dataTable.value && dataTable?.value?.refresh()
}, 300)

onMounted(() => {
  getVehicles()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    refreshTable()
  },
  { deep: true }
)

const getVehicles = () => {
  const api = $url.vehicle.vehicle.all
  $api(api, { body: { type: 0 } })
    .then((data) => {
      const resData: any = data?.data?.value

      if (resData?.success) {
        vehicles.value = resData.data || []
      }
      loading.value = false
    })
    .catch(() => {
      vehicles.value = []
      loading.value = false
    })
}
</script>
